export default "__VITE_ASSET__edoe4q98__"